import bs from './Bs/Config';
import ih from './InHouseMethod/Config';

export default {
  ...bs,
  ...ih,
};
